import { useGraph } from "@features/builder/graph/graphAtoms"
import { lockMemberAtom } from "@features/builder/hooks/socketIOHooks"
import { SocketRoomPrefix } from "@features/builder/types"
import { useAtomValue } from "jotai"

const useLockedNodesIds = (): string[] => {
  const { graphId } = useGraph()
  const lockMember = useAtomValue(lockMemberAtom)

  if (!graphId) return []

  const lockedNodesIds = lockMember.get(`${SocketRoomPrefix.CRDT}-${graphId}`)?.keys() || []

  return Array.from(lockedNodesIds)
}

export default useLockedNodesIds
